import React, { Component } from "react";
import { Link,NavLink } from "react-router-dom";
import RightIconMenu from "../RightIconMenu";
import "./index.css";
// import BasicSoundPlayer  from '../../Elements/AWSSoundPlayer';
export default class View_type_16 extends Component {
	constructor(props) {
		super(props);
		//console.log("View_type_14 ", props);
		var data = Array.isArray(props.data) ? props.data[0] : props.data;
		this.state = {
			data: data,
			r_menu: data.right_menu ? data.right_menu : [],
			r_menu_serach: data.right_menu_serach ? data.right_menu_serach : [],
			title: data.title ? data.title : "",
			tabs: data.tabs ? props.data.tabs : [],
			content: data.content ? data.content : [],
			read_more: data.read_more ? data.read_more : [],
			list: data.list ? data.list : [],
			content_title: data.content_title ? data.content_title : null,
			rightIconMenu: data.right_icon_menu ? data.right_icon_menu : [],

		};
		// console.log('ADUO',this.state.audio);
	}

	createMarkup(item) {
		return { __html: item };
	}

	inputHandler = e => {
		//console.log(e.target.value);
	};

	render() {
		//console.log("multimedia test", this.props.data.multimedia);
		const { description, title_image, table,pagination } = this.props.data;
		var _this = this;
		var var1 = this.state.data.title ? this.state.data.title : "";


		return (
			<div className="vt2">
				<div className="vt2 left col-xs-12 col-sm-12 col-md-8 col-lg-9">
					<div className="vt2 row">
						<div className="vt2-title">
							<div
								className="vt2-title-name vt14-title-name artists-pageTitle"
								dangerouslySetInnerHTML={{ __html: var1 }}
							/>


							<h2 className="vt14-content__title">
								{this.state.content_title}
							</h2>


							<div className="vt2-title-tabs">
								<h2 className="vt16 editions-title">SSSherzooo</h2>
								<div className="row vt14 schedule__wrapper" >
									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Tytuł:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.genre} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Dedykacja:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.mood} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Wydawnictwo:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.opus} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Data wydania:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.date_start} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Miejsce wydania:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.wg_paderewskiego} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Numer wydawniczy:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.wg_turbo} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Format:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.cast} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Liczba stron:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.dedicated} */}
									</div>

									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Reprodukcja:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.sources} */}
									</div>


									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Uwagi:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right schedule__border--pierwodruki">
										{" "}
										<span
											style={{
												display: "block"
											}}
										>
											{/* {elem.editions} */}
										</span>
										<span
											style={{
												display: "block"
											}}
										>
											{/* {elem.editions} */}
										</span>
										<span
											style={{
												display: "block"
											}}
										>
											{/* {elem.editions} */}
										</span>
									</div>
									<div className="col-sm-5 col-xs-12 vt14 schedule__border">
										{" "}
										Inne Wydania:
									</div>
									<div className="col-sm-7 col-xs-12 vt14 schedule__border schedule__border--right">
										{" "}
										{/* {elem.sources} */}
									</div>
								</div>
							</div>
							<strong>Więcej o utworze</strong>

						</div>
						<div className="vt2-content">
							<div
								dangerouslySetInnerHTML={_this.createMarkup(this.state.content)}
							/>
						</div>
						<div>

						</div>

					</div>
				</div>
				<div className="vt2 right col-xs-3 col-sm-3 col-md-3 col-lg-3">
					{this.state.r_menu.length > 2 ? (
						<div className="vt2 RightMenu">
							<ul className="vt2 right_menu_items">
								{this.state.r_menu.map(function(object, i) {
									var var4 = object.url ? object.url : "";
									var var5 = object.name ? object.name : "";
									//console.log("RightMenu", object);
									return (
										<li className="vt2 left-menuItem" key={i}>
											<Link className="vt2 left-menuUnit" to={"/" + var4}>
												{var5}
											</Link>
										</li>
									);
								})}
							</ul>
						</div>
					) : (
            <div className="vt2 RightMenu vt14 RightMenu">
							{this.state.rightIconMenu &&
								<RightIconMenu data={this.state.rightIconMenu}/>
							}
							{this.props.data.right_menu_serach_option && (
								<div>
									<span className="vt14 RightMenu__serach-title">
										szukaj wg:
									</span>
									<label className="vt14 RightMenu__serach-label">
										<p>Tytuł</p>
										<input
											className="vt14 RightMenu__serach-input"
											type="text"
										/>
									</label>
									<ul className="vt2 right_menu_items RightMenu list">
										{this.state.r_menu_serach.map(function(object, i) {
											var var4 = object.url ? object.url : "";
											var var5 = object.name ? object.name : "";
											return (
												<li className="vt2 RightMenu item" key={i}>
													<Link to={"/" + var4}>{var5}</Link>
												</li>
											);
										})}
									</ul>
								</div>
							)}
							{pagination && (
								<ul className="vt2 right_menu_items RightMenu list">
									{pagination.map(function(object, i) {
										var var4 = object.url ? object.url : "";
										var var5 = object.name ? object.name : "";
										//console.log("RightMenu", object);
										return (
											<li className="vt2 RightMenu item" key={i}>
												<Link to={"/" + var4}>{var5}</Link>
											</li>
										);
									})}
								</ul>
							)}
						</div>
					)}
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/Components/Elements/View_type_16/index.js